<script>
    export let data;

    import {Button} from "carbon-components-svelte";
    import FolderAdd20 from "carbon-icons-svelte/lib/FolderAdd20";
    import EnumStatus from "../services/taskstatus";
    import {updateTask} from "../store";

    function updateTaskDo() {
        data.setStatus(EnumStatus.ASAP);
        data = data;
        updateTask(data)
    }

    let taskid = data.id;
</script>

<Button kind="ghost" iconDescription="Add to an existing project" on:click={updateTaskDo} icon={FolderAdd20}
></Button
>

<!-- <style>
Button {
    text-align: center;
    padding: 0em;
    max-width: 240px;
    margin: 0 auto;
}
</style> -->